import {Box, Grid, TextField, Typography, styled} from "@mui/material";
import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import MWCaption from "../../components/MWCaption";

import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";

const CategoryFormContainer = styled(Grid)(({theme}) => ({
  justifyContent: "center",
  alignItems: "center",
  height: "400px",
  backgroundColor: "#fff",
  "& p": {
    marginTop: "8px",
  },
}));

const CategoryFormContent = styled(Grid)(({theme}) => ({
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "240px",
  padding: "24px",
  border: `1px solid ${theme.palette.background.paper}`,
  borderRadius: "16px",
  boxShadow:
    "rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem",

  "& label": {
    fontWeight: 600,
    paddingRight: "8px",
  },
}));

const DocumentList = styled(Box)(({theme}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  "& label": {
    flexBasis: "30%",
  },
}));

type SubTitleColorProps = {
  captionColor?: string;
};

const StatisticsItem1Form = ({captionColor}: SubTitleColorProps) => {
  const {control} = useFormContext();
  return (
    <React.Fragment>
      <MWCaption title="카테고리" color={captionColor} icon={<SystemUpdateAltIcon />} />
      <CategoryFormContainer container>
        <CategoryFormContent item xs={12} sm={6} md={6} xl={4}>
          <Controller
            name="itemName"
            control={control}
            defaultValue={""}
            render={({field, fieldState: {error}}) => (
              <DocumentList>
                <label htmlFor="name">분류명 : </label>
                <TextField
                  {...field}
                  id="name"
                  size="small"
                  placeholder="분류명"
                  margin="dense"
                  autoFocus
                  helperText={error?.message}
                  sx={{width: "100%"}}
                />
              </DocumentList>
            )}
          />
          <Controller
            name="displayOrder"
            control={control}
            defaultValue={""}
            render={({field, fieldState: {error}}) => (
              <DocumentList>
                <label htmlFor="name">표시순서 : </label>
                <TextField
                  {...field}
                  id="name"
                  size="small"
                  type="number"
                  placeholder="표시순서"
                  margin="dense"
                  helperText={error?.message}
                  sx={{width: "100%"}}
                />
              </DocumentList>
            )}
          />
        </CategoryFormContent>
      </CategoryFormContainer>
    </React.Fragment>
  );
};

export default StatisticsItem1Form;
